import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { LogoutConfimComponent } from '../logout-confim/logout-confim.component';
import { EventService } from '../service/event.service';
import { SkipToTopContentEvent } from '../service/events';
import { VendorService } from '../service/vendor.service';

@Component({
    selector: 'app-vendor-dashboard',
    templateUrl: './vendor-dashboard.component.html',
    styleUrls: ['./vendor-dashboard.component.scss'],
    standalone: false
})
export class VendorDashboardComponent implements OnInit {

  selected = new UntypedFormControl(0);
  index: string;

  constructor(private eventBus: EventService, private vendorService: VendorService, private router: Router, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.eventBus.emit(new SkipToTopContentEvent({}));

    sessionStorage.setItem('vendorSkip', 'true');
    this.index = sessionStorage.getItem('index');

    if (this.index) {
      this.selected.setValue(this.index);
    } else {
      this.selected.setValue('0');
    }
  }

  selectedTab(event: any) {
    let selected: HTMLDivElement = event.target;
    let selectedTab: string = selected.innerHTML;

    if (selectedTab.includes('Vendor Request Form')) {
      this.emitFocusPage(0);
    } else if (selectedTab.includes('Vendor Batch Request')) {
      this.emitFocusPage(1);
    } else if (selectedTab.includes('Vendor Search Results')) {
      this.emitFocusPage(2);
    } else if (selectedTab.includes('Log Out')) {
      this.onLogout();
    }
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    let tab: any = tabChangeEvent;

    if (tab !== 3) {
      sessionStorage.setItem('index', tab);
      this.emitFocusPage(tab);
    }
  }

  emitFocusPage(tab: number) {
    if (tab === 1) {
      this.vendorService.emitFocusPage("vendorBatchRequest");
    } else if (tab === 2) {
      this.vendorService.emitFocusPage("vendorSearchRequest");
    }
    else {
      this.vendorService.emitFocusPage("vendorRequestForm");
    }
  }

  onLogout() {
    const dialogRef = this.dialog.open(LogoutConfimComponent, {
      role: 'alertdialog'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(["sessionTimedOut"]);
      } else {
        window.location.reload();
      }
    });
  }
}
